export const getDefaultState = () => ({
  listFeatureFlags: [],
});
export const state = getDefaultState();
